import { BarChart } from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

export default function AccountStatsLink() {
  return (
    <Box my={2}>
      <List
        subheader={
          <ListSubheader
            disableSticky
            sx={{ backgroundColor: 'transparent' }}
          >
            Profil
          </ListSubheader>
        }
      >
        <ListItem disablePadding>
          <ListItemButton component={RouterLink} to="/account/stats">
            <ListItemIcon>
              <BarChart />
            </ListItemIcon>
            <ListItemText
              primary="Statistik"
              secondary="Bokningar, historik och träningstid"
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  )
}
